import { Skeleton } from "~/components/ui/skeleton";
import { Card, CardContent } from "~/components/ui/card";

export function PaymentMethodSkeleton() {
  return (
    <Card>
      <CardContent>
        <div className="space-y-4">
          {/* Payment Method Tabs */}
          <div className="space-y-3">
            <Skeleton className="h-4 w-32" />
            <div className="space-y-2">
              <Skeleton className="h-12 w-full rounded-lg" />
              <Skeleton className="h-12 w-full rounded-lg" />
            </div>
          </div>

          {/* Billing Details */}
          <div className="space-y-3">
            <Skeleton className="h-4 w-24" />
            <div className="grid grid-cols-2 gap-3">
              <Skeleton className="h-10 w-full" />
              <Skeleton className="h-10 w-full" />
            </div>
            <Skeleton className="h-10 w-full" />
          </div>

          {/* Payment Button */}
          <div className="pt-4">
            <Skeleton className="h-12 w-full rounded-lg" />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

export function PaymentMethodSelectorSkeleton() {
  return (
    <div className="container mx-auto flex items-center justify-center py-16">
      <div className="space-y-4">
        <Skeleton className="mx-auto h-6 w-32" />
        <div className="space-y-3">
          <Skeleton className="h-12 w-full rounded-lg" />
          <Skeleton className="h-12 w-full rounded-lg" />
          <Skeleton className="h-12 w-full rounded-lg" />
        </div>
        <Skeleton className="mx-auto h-10 w-24" />
      </div>
    </div>
  );
}
